<script>
import baseMixin from '@/mixins/baseMixin'
import timesheetMixin from '@/mixins/timesheetMixin'
import { nanoid } from 'nanoid'
import { TimesheetOperationType } from '@/shared/constants/timesheet/TimesheetOperationType'
import TimesheetCandidateChangesLabel from './timesheet-candidate-changes-label.vue'
import TimesheetRecordsTableActions from './timesheet-records-table-actions.vue'
import TimesheetBookingTime from './timesheet-booking-time.vue'

export default {
  name: 'TimesheetRecordsTable',
  components: {
    TimesheetCandidateChangesLabel,
    TimesheetRecordsTableActions,
    TimesheetBookingTime,
  },
  mixins: [baseMixin, timesheetMixin],
  props: {
    timesheets: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      key: '',
      headers: [
        {
          text: 'Location',
          align: 'start',
          value: 'locationName',
          width: '20%',
        },
        {
          text: 'Date',
          align: 'start',
          value: 'startTimeUTC',
          width: '15%',
          sort: (a, b) => a.toDate() - b.toDate(),
        },
        {
          text: 'Time',
          align: 'start',
          value: 'hours',
          width: '25%',
        },
        {
          text: '',
          align: 'start',
          value: 'changes',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'end',
          value: 'actions',
          width: '25%',
        },
      ],
      selectedTimesheets: [],
      TimesheetOperationType,
    }
  },
  watch: {
    selectedTimesheets: {
      deep: true,
      handler() {
        this.emitSelectedTable()
      },
    },
  },
  created() {
    this.key = nanoid()
    this.emitSelectedTable() // initiate top level's mgnt of the selection
  },
  methods: {
    deselectTimesheet(bookingId) {
      this.selectedTimesheets = this.selectedTimesheets.filter(
        (timesheet) => timesheet.bookingId !== bookingId
      )
    },
    changeTime(timesheet) {
      this.$emit('changeTime', {
        key: this.key,
        timesheet: timesheet,
      })
    },
    cancelBookingSubmitted(payload) {
      this.deselectTimesheet(payload.bookingId)
      this.$emit('cancelBookingSubmitted', payload)
    },
    emitSelectedTable() {
      this.$emit('timesheetsUpdated', {
        key: this.key,
        timesheets: this.selectedTimesheets,
      })
    },
  },
}
</script>

<template>
  <v-data-table
    v-model="selectedTimesheets"
    :headers="headers"
    :items="timesheets"
    :sort-by="['startTimeUTC']"
    :sort-desc="[false]"
    item-key="bookingId"
    disable-pagination
    hide-default-footer
    show-select
    class="elevation-0"
  >
    <template v-slot:[`item.locationName`]="{ item }">
      <p class="mb-0">{{ item.locationName }}</p>
      <p class="mb-0 caption">#{{ item.bookingId }}</p>
    </template>

    <template v-slot:[`item.startTimeUTC`]="{ item }">
      {{ renderDate(item.startTimeUTC, item.locationTimeZone) }}
    </template>

    <template v-slot:[`item.hours`]="{ item }">
      <TimesheetBookingTime :timesheet="item" />
    </template>

    <template v-slot:[`item.changes`]="{ item }">
      <TimesheetCandidateChangesLabel :timesheet="item" />
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <TimesheetRecordsTableActions
        :timesheet="item"
        @changeTime="changeTime"
        @cancelBookingSubmitted="cancelBookingSubmitted"
      />
    </template>
  </v-data-table>
</template>
